module.exports = __webpack_public_path__ + "static/media/empty-state-help.1f9e07ed.svg";